import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import { base_url } from '../../Utils/baseUrl';
import { config } from '../../Utils/axiosconfig';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ReceiptModal = ({ isRecOpen, closeRecModal, data, userData }) => {

    const { t } = useTranslation();
    const requestConfig = { ...config };
    const [loading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const calculateTax = (totalPrice) => {
        const price = Number(totalPrice || 0);
        return price * 0.25;
    };

    const totalPrice = Number(data?.totalPrice || 0);
    const taxAmount = calculateTax(totalPrice);
    const subtotal = totalPrice - taxAmount;

    const customerName = userData?.user?.data?.firstName || data?.Child?.name;
    const totalQuantity = (data?.OrdersItems || []).reduce((sum, item) => sum + Number(item.quantity || 1), 0);
    const items = data?.OrdersItems || [];

    let receiptData = {
        subject: `Ordrebekræftelse #${data?.id}`,
        message: `<!DOCTYPE html>
        <html>
        <head>
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>Order Confirmation</title>
            <style>
                body {
                    margin: 0;
                    padding: 0;
                    background: #f2f2f2;
                    font-family: Arial, Helvetica, sans-serif;
                    color: #1a1a1a;
                }
                table {
                    border-collapse: collapse;
                }
                img {
                    border: 0;
                    outline: none;
                    text-decoration: none;
                    display: block;
                    object-fit: cover;
                    width: 100%;
                }
                a {
                    text-decoration: none;
                    color: black;
                }

                .footer-email-bottom-box {
                    max-width: 549px;
                    margin: 0 auto;
                }


                .desktop-view-full-mobile .left-view, .desktop-view-full-mobile .right-view {
                    width: 100%;
                    display: block;
                }

                .footer-mobile-email td:nth-child(1) {
                    padding-right: 3px;
                }

                @media only screen and (max-width: 640px) {
                    .container {
                        width: 100% !important;
                    }
                    .content-box {
                        padding-left: 18px !important;
                        padding-right: 18px !important;
                    }
                    .meta-grid .card-box-email {
                        display: block !important;
                        width: 100% !important;
                        box-sizing: border-box;
                    }
                    .order-row td {
                        display: block !important;
                        width: 100% !important;
                    }
                    .mobile-hide {
                        display: none !important;
                    }
                    .order-confirmation {
                        font-size: 22px !important;
                        line-height: 26px !important;
                    }
                    .padding-email {
                        padding: 15px !important;
                    }

                    .full-mobile-line {
                        width: 100%;
                        display: block !important;
                        
                    }

                    .card-box-email td:nth-child(2) span:nth-child(2) {
                        text-align: right !important;                         
                        width: calc(100% - 90px)!important;
                        display: inline-block !important;
                    }

                    td.card-box-email {
                        padding: 10px 0 !important;
                        border-bottom: 1px solid #e8e8e8;
                    }
                    .content-box.footer-email-table td {
                        width: 100% !important;
                    }

                    .content-box.footer-email-table td.no-need-for-mobile {
                        display: none !important;
                    }

                    .content-box.email-text-icons td span {
                        width: 25px !important;
                    }

                    .content-box.email-text-icons td {
                        font-size: 14px !important;
                        line-height: 20px !important;
                    }

                    .footer-mobile-email {
                        width: 100%;
                        display: block;
                    }
                    .footer-mobile-email span , .footer-mobile-email a {
                        text-align: left;
                        display: block !important;
                            
                        width: 100% !important;
                    }   

                    .footer-mobile-email img {
                        width: 23px;height: 23px;display: block;
                        aspect-ratio: initial !important;
                    }

                    .footer-mobile-email table td:nth-child(1) {
                        width: 29px !important;
                    }

                    .footer-mobile-email table td:nth-child(2) {
                        width: 100% !important;text-align: left;
                    }

                    .footer-mobile-email:nth-child(1) table td:nth-child(1) img {
                        width: 17px;
                        height: 17px;
                    }
                    td.footer-mobile-email-line {
                        width: 100%;
                        display: none;
                    }

                    .desktop-view-full-mobile .left-view {
                        text-align: left;
                        width: 38%;
                        display: inline-block;
                    }

                    .desktop-view-full-mobile .right-view {
                        text-align: right;
                        width: 62%;
                        display: inline-block;
                    }

                    .desktop-view-full-mobile .left-view span {
                        font-size: 14px;
                    }

                    .receipt-footer-mobile {
                        display: block !important;
                    }
                        .receipt-mobile-item-space {
                        display: block !important;
                        max-width: 100% !important;
                        padding: 4px  !important
                        }

                    .receipt-footer-original {
                        display: none !important;
                    }

                    .receipt-footer-mobile .footer-email-logo {
                        max-width: 100% !important;
                        padding: 0 0 16px !important;
                    }

                    .receipt-footer-mobile .footer-email-logo img {
                        width: 100% !important;
                        max-width: 330px !important;
                        height: auto !important;
                        margin: 0 auto;
                    }

                    .receipt-footer-mobile .footer-email-bottom-box,
                    .receipt-footer-mobile .footer-email-bottom-box tbody,
                    .receipt-footer-mobile .footer-email-bottom-box tr
                    {
                        display: block !important;
                        width: 100% !important;
                    }

                    .receipt-mobile-item {
                        padding: 0 0 10px !important;
                    }

                    .receipt-mobile-item {
                        border: 1px solid #dedede !important;
                        border-radius: 12px !important;
                        padding: 10px !important
                    }
                    .receipt-footer-card {
                        width: 100% !important;
                       border: none !important;
                    }


                    .receipt-footer-card-icon span {
                        display: flex;
                        padding: 8px 8px;
                        align-items: center;
                    }

                    .receipt-footer-card-content {
                        padding-left: 8px !important;
                        font-size: 13px !important;
                        line-height: 20px !important;
                        width: 100%
                    }

                    .receipt-footer-card-label {
                        color: #777777 !important;
                        font-size: 12px !important;
                        font-weight: 400 !important;
                    }

                    .receipt-footer-card-arrow {
                        padding-right: 0px !important;
                    }
                        .receipt-footer-card-icon svg {
                        width: 25px;
                        height: 25px;
                    }

                    .footer-email-box {
                        padding: 0 15px 15px !important;
                    }
                    .receipt-footer-card-icon img {
                        width: 18px !important;
                        height: 18px !important;
                    }
                    .receipt-footer-card-icon + td {
                        width: 100%
                    }

                .receipt-footer-card {
                    border: 1px solid #dedede;
                    border-radius: 12px;
                }

            

                .receipt-footer-card-icon img {
                    width: 26px !important;
                    height: 26px !important;
                    margin: 0 auto;
                    object-fit: contain !important;
                }

                .receipt-footer-card-arrow {
                    color: #888888;
                    font-size: 28px;
                    text-align: right;
                }
                }
            </style>
        </head>
        <body>
            <div style="display:none;font-size:1px;line-height:1px;max-height:0;max-width:0;opacity:0;overflow:hidden;mso-hide:all;"> Din ordre er bekræftet Hej ${customerName}, Tak for din bestilling. Herunder kan du se detaljerne for din skolemadsordre.
            &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
             &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
             &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;              &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;    &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
            </div> 
            <div style="
                display:none;
                display:none !important;
                mso-hide:all;
                font-size:1px;
                line-height:1px;
                max-height:0;
                max-width:0;
                opacity:0;
                overflow:hidden;
                visibility:hidden;
                color:transparent;
                width:0;
                height:0;
            ">
                &#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;&#8203;
            </div>
            <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f2f2f2" style="background:#f2f2f2; margin:0; padding:0; width:100%;">
                <tr>
                    <td style="padding:28px 20px;">
                        <table class="container" width="760" cellpadding="0" cellspacing="0" border="0" bgcolor="#ffffff" style="width:760px; max-width:760px; background:#ffffff; border:1px solid #e7e7e7; border-radius:16px; overflow:hidden;margin: 0 auto;">
                            <tr>
                                <td align="center" class="padding-email" style="padding:24px 30px 14px; background:#ffffff;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td align="center" style="padding:0; font-family:Arial, Helvetica, sans-serif; font-size:20px; font-weight:700; color:#fdab3d;">
                                                <span style="display:inline-block;">
                                                    <img src="https://onlineskolemad.dk/assets/img/email-header-logo.svg">
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-confirmation" align="center" style="font-family:Arial, Helvetica, sans-serif; font-size:38px; line-height:52px; color:#141414; font-weight:700; letter-spacing:-1px; padding-bottom:2px;">
                                                Din ordre er bekræftet
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" style="font-family:Arial, Helvetica, sans-serif; padding-bottom:14px;">
                                                <div style="font-size:17px; line-height:26px; color: #4c4c4c; font-weight:350;">Hej ${customerName},</div>
                                                <div style="font-size:14px; line-height:22px; color: #4c4c4c;">Tak for din bestilling. Herunder kan du se detaljerne for din skolemadsordre.</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" style="padding-bottom:22px;">
                                                <table cellpadding="0" cellspacing="0" border="0" style="background: #f9b1004a; border:none; border-radius:100px; display:inline-block;">
                                                    <tr>
                                                        <td class="btn-check" style="padding:4px 0px 0px 6px; vertical-align: middle;">
                                                            <span style="display:inline-block; width: 25px; height: 25px;padding-right: 6px">
                                                                <img src="https://onlineskolemad.dk/assets/img/email-check.svg">
                                                           </span> 
                                                        </td><td class="btn-check" style="padding:0px 10px 2px 0px; font-family:Arial, Helvetica, sans-serif; font-size:12px; color: #75604A; font-weight: 350;vertical-align: middle;">
                                                           Ingen abonnement - bestil kun når du vil
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="content-box" style="padding:0 32px 5px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td style="border-top:1px solid #e8e8e8;">
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="content-box" style="padding:0px 32px 5px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td style="font-family:Arial, Helvetica, sans-serif; font-size:22px; font-weight:700; color:#1a1a1a; padding-bottom:15px;">
                                                Ordredetaljer
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <table width="100%" cellpadding="0" cellspacing="0" border="0" class="meta-grid">
                                                    <tr>
                                                        <td class="card-box-email" style="padding:0 5px;min-width: 130px">
                                                           
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                    <tr>
                                                                    <td style="padding-right:6px; width: 30px">
                                                                            <span style="display:block; width: 30px; height: 30px"><img src="https://onlineskolemad.dk/assets/img/email-calendar.svg"></span>
                                                                        </td>

                                                                    <td style="padding:0; font-size:15px; font-weight:400; color:#1a1a1a; font-family:Arial, Helvetica, sans-serif;">
                                                                        <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                            <tr class="desktop-view-full-mobile">
                                                                                <td class="left-view">
                                                                                    <span>Dato</span>
                                                                                </td>
                                                                                <td class="right-view">
                                                                                    <span style="font-weight:700;color: #000;margin-top: 2px; display:block;font-size:13px;">${data?.deliveryDate || 'N/A'}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                        
                                                                    </td>

                                                                    </tr>
                                                                </table>
                                                        </td>
                                                         <td style="border-right:1px solid #e8e8e8;" class="full-mobile-line"></td>
                                                        <td class="card-box-email" style="padding:0 5px;min-width: 150px">
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                    <tr>
                                                                    <td style="padding-right:6px;width: 30px">
                                                                            <span style="display:block; width: 30px; height: 30px"><img src="https://onlineskolemad.dk/assets/img/email-school.svg"></span>
                                                                        </td>
                                                                        <td style="padding:0; font-size:15px; font-weight:400; color:#1a1a1a; font-family:Arial, Helvetica, sans-serif;">
                                                                           
                                                                         <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                            <tr class="desktop-view-full-mobile">
                                                                                <td class="left-view">
                                                                                    <span>Skole</span>
                                                                                </td>
                                                                                <td class="right-view">
                                                                                    <span style="font-weight:700;color: #000;margin-top: 2px; display:block;font-size:13px;">${data?.Child?.School?.schoolName || 'Taastrup'}</span>
                                                                                </td>
                                                                            </tr>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                        </td>
                                                         <td style="border-right:1px solid #e8e8e8;" class="full-mobile-line"></td>
                                                        <td class="card-box-email" style="padding:0 5px;min-width: 100px">
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                <tr>
                                                                <td style="padding-right:6px;width: 30px">
                                                                        <span style="display:block; width: 30px; height: 30px"><img src="https://onlineskolemad.dk/assets/img/email-users.svg"></span>
                                                                    </td>
                                                                    <td style="padding:0; font-size:15px; font-weight:400; color:#1a1a1a; font-family:Arial, Helvetica, sans-serif;">
                                                                        <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                            <tr class="desktop-view-full-mobile">
                                                                                <td class="left-view">
                                                                                    <span>Klasse</span>
                                                                                </td>
                                                                                <td class="right-view">
                                                                                    <span style="font-weight:700;color: #000;margin-top: 2px; display:block;font-size: 13px;">${data?.Child?.SchoolClass?.className || '1A'}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                        
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                         <td style="border-right:1px solid #e8e8e8;" class="full-mobile-line"></td>
                                                         <td class="card-box-email" style="padding:0 5px;min-width: 140px">
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                <tr>
                                                                    <td style="padding-right:6px; width: 30px">
                                                                            <span style="display:block; width: 30px; height: 30px"><img src="https://onlineskolemad.dk/assets/img/email-document.svg"></span>
                                                                    </td>

                                                                    <td style="padding:0; font-size:15px; font-weight:400; color:#1a1a1a; font-family:Arial, Helvetica, sans-serif;">
                                                                        <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                            <tr class="desktop-view-full-mobile">
                                                                                <td class="left-view">
                                                                                    <span>Bestillings-ID</span>
                                                                                </td>
                                                                                <td class="right-view">
                                                                                    <span style="font-weight:700;color: #000;margin-top: 2px; display:block;font-size: 13px">#${data?.id || 0}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                        
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                        <td style="border-right:1px solid #e8e8e8;" class="full-mobile-line"></td>
                                                        <td class="card-box-email" style="padding: 0 5px;min-width: 100px">
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                                                    <tr >
                                                                        <td style="padding-right:6px; width: 30px">
                                                                            <span style="display:block; width: 30px; height: 30px"><img src="https://onlineskolemad.dk/assets/img/email-terminal.svg"></span>
                                                                        </td>

                                                                    <td style="padding:0; font-size:15px; font-weight:400; color:#1a1a1a; font-family:Arial, Helvetica, sans-serif;margin-right: 3px">
                                                                        <table width="100%" cellpadding="0" cellspacing="0" border="0" >
                                                                            <tr class="desktop-view-full-mobile">
                                                                                <td class="left-view">
                                                                                    <span>Betaling</span>
                                                                                </td>
                                                                                <td class="right-view">
                                                                                    <span style="font-weight:700;color: #000;margin-top: 2px; display:block;font-size:13px;">Balance</span>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                        
                                                                    </td>
                                                                    </tr>
                                                                </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>

                            <tr>
                                <td class="content-box" style="padding:20px 32px 2px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr><td style="font-family:Arial, Helvetica, sans-serif; font-size:22px; font-weight:700; color:#1a1a1a; padding-bottom:10px;">
                                               Din bestilling
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border-top:1px solid #e8e8e8;">
                                                <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                                    <tr style="font-family:Arial, Helvetica, sans-serif; font-size:15px; line-height:12px; color:#4d4d4d; font-weight:600;">
                                                        <td width="52%" style="padding:14px 0;">Produkt</td>
                                                        <td width="18%" align="center" style="padding:14px 0;">Antal</td>
                                                        <td width="30%" align="right" style="padding:14px 0;">Pris</td>
                                                    </tr>
                                                    ${items.map((item, index) => `
                                                    <tr style="border-top:1px solid #ededed;">
                                                        <td style="padding:5px 0; font-family:Arial, Helvetica, sans-serif; color:#1a1a1a; font-size:16px; font-weight:700;">
                                                            <table cellpadding="0" cellspacing="0" border="0">
                                                                <tr>
                                                                    <td style="padding-right:14px;">
                                                                        <div style="width:54px; height:54px; border-radius:10px; background:#f4e7d2; border:1px solid #d9d9d9; overflow:hidden; position:relative;">
                                                                            <img src="https://api.onlineskolemad.dk//uploads/menu-img/${item.image}" />
                                                                        </div>
                                                                    </td>
                                                                    <td>${item.itemName || 'Menu item'}</td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                        <td align="center" style="padding:5px 0; font-family:Arial, Helvetica, sans-serif; color:#1f1f1f; font-size:14px; font-weight:600;">${item.quantity || 2} x</td>
                                                        <td align="right" style="padding:5px 0; font-family:Arial, Helvetica, sans-serif; font-size:16px; color:#1d1d1d; font-weight:600;">${Number(item.price || 0).toFixed(0)} kr.</td>
                                                    </tr>`).join('')}
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="content-box" style="padding:0 32px 10px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td style="border-top:1px solid #e8e8e8;">
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="content-box footer-email-table" style="padding:0 32px 18px;">
                                    <table cellpadding="0" cellspacing="0" border="0" width="100%">
                                        <tr>
                                            <td style="width:50%" class="no-need-for-mobile"></td>
                                            <td style="width:50%">
                                                <table cellpadding="0" cellspacing="0" border="0" width="100%">
                                                    <tr>
                                                        <td style="font-family:Arial, Helvetica, sans-serif; font-size:15px; color:#2d2d2d; padding:6px 0 6px 16px;">
                                                            <span style="display:inline-block; text-align:left;">I alt ekskl. moms</span>
                                                        </td>
                                                        <td align="right" style="font-family:Arial, Helvetica, sans-serif; font-size:15px; color:#2d2d2d; padding:6px 18px;min-width: 100px">
                                                            <span style="font-weight:600; color:#1a1a1a;text-align:right;display:inline-block;">${Number(subtotal || 0).toFixed(2)} kr.</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="font-family:Arial, Helvetica, sans-serif; font-size:15px; color:#2d2d2d; padding:6px 0 6px 16px;">
                                                            <span style="display:inline-block; text-align:left;">Moms (25%)</span>
                                                        </td>
                                                        <td align="right" style="font-family:Arial, Helvetica, sans-serif; font-size:15px; color:#2d2d2d; padding:6px 18px;min-width: 100px">
                                                            <span style="font-weight:600; color:#1a1a1a;text-align:right;display:inline-block;">${taxAmount.toFixed(2)} kr.</span>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td style="padding-top:10px;" colspan="2" >
                                                            <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background: #fdab3d; border:none; border-radius:10px;">
                                                                <tr>
                                                                    <td style="font-family:Arial, Helvetica, sans-serif; font-size:20px; font-weight:700; color:#1a1a1a; text-align:left; padding:16px 18px;">
                                                                        <span style="display:inline-block; text-align:left;">I alt</span>
                                                                    </td>
                                                                    <td align="right" style="font-family:Arial, Helvetica, sans-serif; font-size:18px; color:#2d2d2d; padding:6px 18px;min-width: 100px;font-weight: 700">
                                                                        <span>${totalPrice.toFixed(2)} kr.</span>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>

                            <tr>
                                <td class="content-box email-text-icons" style="padding:0 32px 10px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background: #f9b1004a; border:none; border-radius:12px;">
                                        <tr>
                                            <td style="padding:14px 18px;">
                                                <table cellpadding="0" cellspacing="0" border="0">
                                                    <tr>
                                                        <td valign="top" style="padding-right:12px;    vertical-align: middle;">
                                                            <span style="display:inline-block; width: 36px; height: 36px"><img src="https://onlineskolemad.dk/assets/img/email-information.svg"></span>
                                                        </td>
                                                        <td style="font-family:Arial, Helvetica, sans-serif; font-size:16px; line-height:22px; color:#1d1d1d;">
                                                            <div style="font-weight:700;">Maden leveres til skolen på den valgte dag.</div>
                                                            <div>Har du spørgsmål, er du velkommen til at kontakte os.</div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="content-box" style="padding:0 32px 10px;">
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                                        <tr>
                                            <td style="border-top:1px solid #e8e8e8;">
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td class="footer-email-box" style="padding:0 32px 26px; font-family:Arial, Helvetica, sans-serif; color:#1e1e1e;">
                                    <div class="receipt-footer-original" align="center" style="font-size:20px; font-weight:700; color:#fdab3d; padding-bottom:4px;max-width:200px; text-align:center; display:block; width:100%;margin:0 auto;">
                                        <img src="https://onlineskolemad.dk/assets/img/email-logo.png">
                                    </div>
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0" class="footer-email-bottom-box receipt-footer-original">
                                        <tr>
                                            <td class="footer-mobile-email" valign="middle" style="font-size:16px; color:#2e2e2e; padding:5px;">
                                                <table width="100%" cellpadding="0" cellspacing="0" border="0"><tr>
                                                    <td style="text-align:left;width:20%;padding-right: 5px"><img src="https://onlineskolemad.dk/assets/img/email-call.svg" width="16" height="16" style="border:0; margin-right:9px; object-fit:contain;"></td>
                                                    <td style="text-align:left;width:85%">26 22 74 69</td>
                                                </tr></table>
                                            </td>
                                            <td class="footer-mobile-email-line" width="1" valign="middle"><span style="color:#b7b7b7;">|</span></td>
                                            <td class="footer-mobile-email" valign="middle" style="font-size:16px; color:#2e2e2e; padding:5px;">
                                                <table width="100%" cellpadding="0" cellspacing="0" border="0"><tr>
                                                    <td style="text-align:left;width:15%"><img src="https://onlineskolemad.dk/assets/img/email-message.svg" width="20" height="20" style="border:0; margin-right:3px; object-fit:contain;"></td>
                                                    <td style="text-align:left;width:85%;color:#2e2e2e;">onlineskolemad@hotmail.com</td>
                                                </tr></table>
                                            </td>
                                            <td class="footer-mobile-email-line" width="1" valign="middle"><span style="color:#b7b7b7;">|</span></td>
                                            <td class="footer-mobile-email" valign="middle" style="font-size:16px; padding:5px;">
                                                <table width="100%" cellpadding="0" cellspacing="0" border="0"><tr>
                                                    <td style="text-align:left;width:15%"><img src="https://onlineskolemad.dk/assets/img/email-web.svg" width="20" height="20" style="border:0; margin-right:3px; object-fit:contain;"></td>
                                                    <td style="text-align:left;width:85%"><a href="https://onlineskolemad.dk/" style="color:#2e2e2e; text-decoration:none;">onlineskolemad.dk</a></td>
                                                </tr></table>
                                            </td>
                                        </tr>
                                    </table>
                                    <div class="receipt-footer-mobile" style="display:none;">
                                    <div class="footer-email-logo" align="center" style="padding-bottom:12px; max-width:200px; text-align:center; display:block; width:100%; margin:0 auto;">
                                        <img src="https://onlineskolemad.dk/assets/img/email-logo.png" width="200" alt="Onlineskolemad" style="display:block; width:100%; max-width:200px; height:auto; margin:0 auto;">
                                    </div>
                                    <table width="100%" cellpadding="0" cellspacing="0" border="0" class="footer-email-bottom-box" style="max-width:549px; margin:0 auto;">
                                        <tr>
                                            <td class="receipt-mobile-item" valign="middle" style="padding:5px; width:93%;    display: block;">
                                                <table class="receipt-footer-card" width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #dedede; border-radius:12px;">
                                                    <tr>
                                                        <td class="receipt-footer-card-icon" style=" vertical-align:middle;">
                                                            <span style="width: 25px; height:25px;background:#f9b100; text-align:center;border-radius:12px;">
                                                                <img src="https://onlineskolemad.dk/assets/img/call-mobile.svg" width="20" height="20" style="border:0; margin-right:3px; object-fit:contain;">
                                                            </span>
                                                        </td>
                                                        <td class="" valign="middle" >
                                                            <table class="receipt-footer-card-new" width="100%" cellpadding="0" cellspacing="0" border="0">
                                                                <tr>
                                                                    <td class="receipt-footer-card-content" style="padding:5px 6px 5px 10px; font-size:16px; line-height:20px; font-weight:700; color:#1e1e1e;">
                                                                         <a href="tel:26227469" style="color:#1e1e1e; text-decoration:none;">26 22 74 69</a><br>
                                                                        <span class="receipt-footer-card-label" style="font-size:13px; font-weight:400; color:#777777;">Ring til os</span>
                                                                    </td>
                                                                    <td class="receipt-footer-card-arrow" style=" padding-right:8px; color:#888888; font-size:26px; text-align:right;">&#8250;</td>
                                                                </tr>
                                                          </table>  
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="receipt-mobile-item-space" ></td>
                                            <td class="receipt-mobile-item" valign="middle" style="padding:5px; width:93%;    display: block;">
                                                <table class="receipt-footer-card" width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #dedede; border-radius:12px;">
                                                    <tr>
                                                        <td class="receipt-footer-card-icon" style=" vertical-align:middle;">
                                                            <span style="width: 25px; height:25px;background:#f9b100; text-align:center;border-radius:12px;">
                                                                <img src="https://onlineskolemad.dk/assets/img/mail-mobile.svg" width="20" height="20" style="border:0; margin-right:3px; object-fit:contain;">
                                                                </span>
                                                        </td>
                                                        <td class="" valign="middle" >
                                                            <table class="receipt-footer-card-new" width="100%" cellpadding="0" cellspacing="0" border="0">
                                                                <tr>
                                                                    <td class="receipt-footer-card-content" style="padding:5px 6px 5px 10px; font-size:16px; line-height:20px; font-weight:700; color:#1e1e1e;width:100%">
                                                                         <a href="mailto:onlineskolemad@hotmail.com" style="color:#1e1e1e; text-decoration:none;    word-break: break-all;">onlineskolemad@hotmail.com</a><br>
                                                                        <span class="receipt-footer-card-label" style="font-size:13px; font-weight:400; color:#777777;">Send en e-mail</span>
                                                                    </td>
                                                                    <td class="receipt-footer-card-arrow" style=" padding-right:8px; color:#888888; font-size:26px; text-align:right;">&#8250;</td>
                                                                </tr>
                                                          </table>  
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td class="receipt-mobile-item-space" ></td>
                                            <td class="receipt-mobile-item" valign="middle" style="padding:5px; width:93%;    display: block;">
                                                <table class="receipt-footer-card" width="100%" cellpadding="0" cellspacing="0" border="0" style="border:1px solid #dedede; border-radius:12px;">
                                                    <tr>
                                                        <td class="receipt-footer-card-icon" style=" vertical-align:middle;">
                                                            <span style="width: 25px; height:25px;background:#f9b100; text-align:center;border-radius:12px;">
                                                                <img src="https://onlineskolemad.dk/assets/img/site-mobile.svg" width="20" height="20" style="border:0; margin-right:3px; object-fit:contain;">
                                                            </span>
                                                        </td>
                                                        <td class="" valign="middle" >
                                                            <table class="receipt-footer-card-new" width="100%" cellpadding="0" cellspacing="0" border="0">
                                                                <tr>
                                                                    <td class="receipt-footer-card-content" style="padding:5px 6px 5px 10px; font-size:16px; line-height:20px; font-weight:700; color:#1e1e1e;width:100%">
                                                                        <a href="https://onlineskolemad.dk/" style="color:#1e1e1e; text-decoration:none;    word-break: break-all;">onlineskolemad.dk</a><br>
                                                                        <span class="receipt-footer-card-label" style="font-size:13px; font-weight:400; color:#777777;">Besøg vores hjemmeside</span>
                                                                    </td>
                                                                    <td class="receipt-footer-card-arrow" style=" padding-right:8px; color:#888888; font-size:26px; text-align:right;">&#8250;</td>
                                                                </tr>
                                                          </table>  
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </body>
        </html>
        `,
    };

    const handleSubmit = async () => {
        try {
            setErrorMessage('');
            setLoading(true);

            await axios.post(`${base_url}sendemail`, receiptData, requestConfig)
                .then((res) => {
                    if (res) {
                        setLoading(false);
                        setIsSuccess(true);
                    }
                })
                .catch((err) => {
                    console.log(err, 'err');
                    const message = err?.response?.data?.message || err?.message || 'Something went wrong';
                    setErrorMessage(message);
                    setIsSuccess(false);
                    setLoading(false);
                });
        } catch (error) {
            console.log(error, 'error');
            setErrorMessage('Something went wrong');
            setIsSuccess(false);
            setLoading(false);
        }
    };

    const emailAddress = userData?.user?.data?.email || 'dummy@dummy.com';

    const handleClose = () => {
        setIsSuccess(false);
        setErrorMessage('');
        setLoading(false);
        setIsPreviewOpen(false);
        closeRecModal();
    };

    return (
        <>
            <Dialog
                open={isRecOpen}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        width: '100%',
                        maxWidth: isSuccess || Boolean(errorMessage) ? '420px' : '500px',
                        borderRadius: '14px',
                        backgroundColor: '#f5f5f5',
                        boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.08)',
                        overflow: 'hidden',
                        m: 2
                    }
                }}
                sx={{
                    '& .MuiDialog-container': {
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(17, 17, 17, 0.35)'
                    }
                }}
            >
                {isSuccess ? (
                    <Box sx={{ px: 3, py: 3.5, textAlign: 'center', backgroundColor: '#fff' }}>
                        <Box
                            sx={{
                                width: 76,
                                height: 76,
                                borderRadius: '50%',
                                backgroundColor: '#39c66b',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 2,
                                color: '#fff',
                                fontSize: '2.6rem',
                                fontWeight: 700,
                                lineHeight: 1,
                                boxShadow: 'inset 0 0 0 2px rgba(255,255,255,0.28)'
                            }}
                        >
                            ✓
                        </Box>

                        <Typography sx={{ fontSize: '2rem', fontWeight: 700, color: '#1b1b1b', mb: 1 }}>
                            {t("userProfile.Receiptsent")}
                        </Typography>

                        <Typography sx={{ fontSize: '1.1rem', color: '#1b1b1b', mb: 3 }}>
                            {t("userProfile.Thereceipthasbeensentto")}<br />
                            <Box component="span" sx={{ fontWeight: 700 }}>{emailAddress}</Box>
                        </Typography>

                        <Button
                            onClick={handleClose}
                            variant="contained"
                            sx={{
                                minWidth: 160,
                                borderRadius: '8px',
                                backgroundColor: '#1d7ae5',
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '1rem',
                                px: 3,
                                py: 1.5,
                                textTransform: 'uppercase',
                                boxShadow: 'none',
                                '&:hover': { backgroundColor: '#1769d0', boxShadow: 'none' }
                            }}
                        >
                            {t("common.close")}
                        </Button>
                    </Box>
                ) : Boolean(errorMessage) ? (
                    <Box sx={{ px: 3, py: 3.5, textAlign: 'center', backgroundColor: '#fff' }}>
                        <Box
                            sx={{
                                width: 76,
                                height: 76,
                                borderRadius: '50%',
                                backgroundColor: '#ffb9b4',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mx: 'auto',
                                mb: 2,
                                color: '#e22626',
                                fontSize: '2.6rem',
                                fontWeight: 700,
                                lineHeight: 1,
                                boxShadow: 'inset 0 0 0 2px rgba(255,255,255,0.28)'
                            }}
                        >
                            !
                        </Box>

                        <Typography sx={{ fontSize: '2rem', fontWeight: 700, color: '#1b1b1b', mb: 1 }}>
                            {t("userProfile.recieptSentError") || 'Error'}
                        </Typography>

                        <Typography sx={{ fontSize: '1.05rem', color: '#1b1b1b', mb: 3 }}>
                            {t("userProfile.recieptSentErrorMsg")}
                        </Typography>

                        <DialogActions sx={{ p: 0, justifyContent: 'center', gap: 1.5 }}>
                            <Button
                                onClick={handleClose}
                                sx={{
                                    minWidth: 120,
                                    color: '#1d1d1d',
                                    backgroundColor: 'transparent',
                                    fontWeight: 600,
                                    fontSize: '0.85rem',
                                    letterSpacing: '0.04em',
                                    textTransform: 'uppercase',
                                    px: 1.5,
                                    py: 1,
                                    '&:hover': { backgroundColor: 'transparent' }
                                }}
                            >
                                {t("common.cancel")}
                            </Button>
                            <Button
                                onClick={handleSubmit}
                                variant="contained"
                                sx={{
                                    minWidth: 140,
                                    borderRadius: '8px',
                                    backgroundColor: '#1d7ae5',
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: '0.9rem',
                                    letterSpacing: '0.04em',
                                    textTransform: 'uppercase',
                                    px: 2.5,
                                    py: 1.1,
                                    boxShadow: 'none',
                                    '&:hover': { backgroundColor: '#1769d0', boxShadow: 'none' }
                                }}
                            >
                                {t("common.send")}
                            </Button>
                        </DialogActions>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            px: { xs: 2.2, sm: 3 },
                            py: { xs: 2.5, sm: 3 },
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            backgroundColor: '#f5f5f5'
                        }}
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 700,
                                color: '#1e1e1e',
                                fontSize: { xs: '1.6rem', sm: '2rem' },
                                lineHeight: 1.2,
                                mb: 2
                            }}
                        >
                            {t("userProfile.orderReceipt")}
                        </Typography>

                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, mb: 2.5 }}>
                            <Typography
                                sx={{
                                    fontSize: { xs: '0.9rem', sm: '1rem' },
                                    lineHeight: 1.4,
                                    color: '#1e1e1e',
                                    fontWeight: 500
                                }}
                            >
                                {t("userProfile.Thereceiptwillbesentto")}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: { xs: '1rem', sm: '1.2rem' },
                                    lineHeight: 1.3,
                                    color: '#1e1e1e',
                                    fontWeight: 700,
                                    wordBreak: 'break-word'
                                }}
                            >
                                {emailAddress}
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                fontSize: { xs: '0.95rem', sm: '1.05rem' },
                                lineHeight: 1.5,
                                color: '#1e1e1e',
                                mb: 3,
                                fontWeight: 400
                            }}
                        >
                            {t("userProfile.ClickSendtocontinue")}
                        </Typography>

                        <DialogActions sx={{ p: 0, width: '100%', justifyContent: 'flex-end', alignItems: 'center', gap: 1.5 }}>
                            {loading === true ? (
                                <Button type="button" disabled sx={{ minWidth: 150, borderRadius: '10px', px: 4, py: 1.5, fontWeight: 700, backgroundColor: '#1d7ae5', color: '#fff', '&.Mui-disabled': { backgroundColor: '#79aef2', color: '#fff' } }}>
                                    {t("userProfile.Sender")}
                                </Button>
                            ) : (
                                <>
                                    {/* <Button
                                        onClick={() => setIsPreviewOpen(true)}
                                        variant="outlined"
                                        sx={{ minWidth: 120, borderRadius: '8px', fontWeight: 700, px: 2.5, py: 1.1 }}
                                    >
                                        Preview
                                    </Button> */}
                                    <Button
                                        onClick={handleClose}
                                        sx={{
                                            minWidth: 125,
                                            color: '#1d1d1d',
                                            backgroundColor: 'transparent',
                                            fontWeight: 600,
                                            fontSize: '0.85rem',
                                            letterSpacing: '0.04em',
                                            textTransform: 'uppercase',
                                            px: 1.5,
                                            py: 1,
                                            '&:hover': { backgroundColor: 'transparent' }
                                        }}
                                    >
                                        {t("common.cancel")}
                                    </Button>
                                    <Button
                                        onClick={handleSubmit}
                                        type="button"
                                        variant="contained"
                                        sx={{
                                            minWidth: 120,
                                            borderRadius: '8px',
                                            backgroundColor: '#1d7ae5',
                                            color: '#fff',
                                            fontWeight: 700,
                                            fontSize: '0.9rem',
                                            letterSpacing: '0.04em',
                                            textTransform: 'uppercase',
                                            px: 2.5,
                                            py: 1.1,
                                            boxShadow: 'none',
                                            '&:hover': { backgroundColor: '#1769d0', boxShadow: 'none' }
                                        }}
                                    >
                                        {t("common.send")}
                                    </Button>
                                </>
                            )}
                        </DialogActions>
                    </Box>
                )}
            </Dialog>
            <Dialog
                open={isPreviewOpen}
                onClose={() => setIsPreviewOpen(false)}
                fullWidth
                maxWidth="lg"
            >
                <DialogContent sx={{ p: 0 }}>
                    <iframe
                        title={`Receipt preview for order ${data?.id || ''}`}
                        srcDoc={receiptData?.message || ''}
                        sandbox=""
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '75vh',
                            border: 0,
                            backgroundColor: '#f2f2f2'
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsPreviewOpen(false)} variant="contained">
                        {t("common.close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ReceiptModal;
